'use strict';

var status = require('../../../../../../../../../../_virtual/status2.cjs');

(function (exports) {

	exports.STATUS_SIZES = void 0;
	(function(STATUS_SIZES) {
	    STATUS_SIZES["small"] = "small";
	    STATUS_SIZES["medium"] = "medium";
	    STATUS_SIZES["large"] = "large";
	})(exports.STATUS_SIZES || (exports.STATUS_SIZES = {}));
	
} (status.__exports));
//# sourceMappingURL=status.cjs.map
